import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_TEAMS_TEAMID_PATH_KEY } from '@/swagger/constants/anagraphics-keys';
import { API_GET_DEPARTMENT_TEAM_DETAILS, KEY_GET_DEPARTMENT_TEAM_DETAILS } from '../constants';
import { MOCK_RESPONSE_GET_DEPARTMENT_TEAM_DETAILS } from '../mocks';
import { DepartmentTeamDetails } from '../types';

type RequestGetDepartmentTeamDetails = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_TEAMS_TEAMID_PATH_KEY
>['request']['path'];

type CallParamsGetDepartmentTeamDetails = Omit<
  RequestGetDepartmentTeamDetails,
  'organizationId'
> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponseGetDepartmentTeamDetails = DepartmentTeamDetails;

type CallErrorGetDepartmentTeamDetails = GenericApiError;

type CallSelectorsGetDepartmentTeamDetails = {
  departmentTeamDetails?: DepartmentTeamDetails;
};

export const getDepartmentTeamDetailsCall = createGeneralCall<
  CallParamsGetDepartmentTeamDetails,
  CallResponseGetDepartmentTeamDetails,
  CallErrorGetDepartmentTeamDetails,
  CallSelectorsGetDepartmentTeamDetails
>({
  id: KEY_GET_DEPARTMENT_TEAM_DETAILS,
  method: 'get',
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_GET_DEPARTMENT_TEAM_DETAILS(org, payload.departmentId, payload.teamId);
    },
  paramsSelector:
    ({ payload }) =>
    () => {
      return payload;
    },
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_DEPARTMENT_TEAM_DETAILS : undefined,
  selectors: {
    departmentTeamDetails: ({ selectors }) =>
      createSelector(selectors.response, res => res || undefined),
  },
});
